/* eslint-disable react/prop-types */
import classNames from "classnames";
import PropTypes from "prop-types";
import { forwardRef, useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import classes from "./infinite-image-carousel.module.scss";
const InfiniteImageCarousel = forwardRef(function InfiniteImageCarousel(
  { items, itemComponent, style: customStyle, className, ...props },
  ref
) {
  const style = {
    ...customStyle,
  };
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: window.innerWidth <= 768 ? 1 : 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 1,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const [maxHeight, setMaxHeight] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(0);
  const slideRefs = useRef([]);

  // Function to update max height
  const updateMaxHeight = () => {
    const heights = slideRefs.current.map((ref) => ref?.clientHeight || 0);
    setMaxHeight(Math.max(...heights));
  };

  // When all images are loaded, update height
  useEffect(() => {
    if (imagesLoaded === items.length) {
      updateMaxHeight();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imagesLoaded]); // Re-run when all images are loaded

  useEffect(() => {
    window.addEventListener("resize", updateMaxHeight);
    return () => {
      window.removeEventListener("resize", updateMaxHeight);
    };
  }, []);

  return (
    <div
      className={classNames(classes.mainContainer, className)}
      style={style}
      {...props}
      ref={ref}
    >
      <Slider {...settings}>
        {items.map((item, index) => (
          <div key={item.id} className="slide">
            <div
              ref={(el) => (slideRefs.current[index] = el)}
              className="slide-content"
              style={{ height: maxHeight || "auto" }} // Dynamically set height
            >
              <itemComponent.type
                key={index}
                item={{
                  ...items[index],
                  onLoad: () => setImagesLoaded((prev) => prev + 1),
                }}
                {...itemComponent.props}
                style={{ height: maxHeight || "auto" }} // Apply max height
                className={classes.item}
              />
            </div>
          </div>
        ))}
      </Slider>
      {/* <Slider {...settings}>
        {items.map((item, index) => {
          return (
            <div
              key={index}
              ref={(el) => (slideRefs.current[index] = el)}
              style={{ height: maxHeight || "auto" }} // Apply max height
            >
              <itemComponent.type
                item={items[index]}
                style={{ height: maxHeight || "auto" }}
                {...itemComponent.props}
                className={classes.item}
              />
            </div>
          );
        })}
      </Slider> */}
    </div>
  );
});

InfiniteImageCarousel.propTypes = {
  items: PropTypes.arrayOf(Object).isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default InfiniteImageCarousel;
